import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation = () => {
    return (
        <nav>
            <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/signals">Signals</Link></li>
                <li><Link to="/positions">Positions</Link></li>
                <li><Link to="/history">Trade History</Link></li>
                <li><Link to="/news">Positions News</Link></li>
                <li><Link to="/aiinsights">AI Inisghts</Link></li>
                <li><Link to="/airecommendations">AI Recommendations</Link></li>
                <li><Link to="/growth">Growth Stocks</Link></li>
            </ul>
        </nav>
    );
};

export default Navigation;